import React, { Component } from 'react';
import {
    Table,
    TableHeaderColumn,
    TableBody,
    TableRow,
    TableHeader,
    TableRowColumn
} from 'material-ui/Table';
import CardType from '../../enums/CardType';
import T from 'i18n-react';
import SortComponent from '../sort/SortComponent';
import { sortAlphabetically } from '../../utils/OrderUtils';
import './TableStripped.css';
import OperationTypeEnum from '../../enums/OperationTypeEnum';
import FilterType from '../../enums/FilterType';
import ColorEnum from '../../enums/ColorEnum';
import OPERATION_CATEGORY from '../../enums/OperationCategoryEnum';
import OperationService from "../../services/OperationService"
import STREAM_TYPE from '../../enums/StreamType';
import { ECOMMERCE_ACTIVITIES } from "../../enums/OperationActivityEnum";

/**
 * Tableau permettant d'afficher les informations CODA & N43
 * Prend en paramètre : Date format "jj-mm-aaaa"
 */
class TableStripped extends Component {

    constructor(props) {
        super(props);
        this.state = {
            location: props.location,
            operationList: props.operationList,
            hasProcessingFees: this.hasCategoryInOperationList(props.operationList, [OPERATION_CATEGORY.PROCESSING_FEES]),
            hasRegularFra: this.hasCategoryInOperationList(props.operationList, [OPERATION_CATEGORY.FRA,OPERATION_CATEGORY.CODA,OPERATION_CATEGORY.N43]),
            hasUnpaidFra: this.hasCategoryInOperationList(props.operationList, [OPERATION_CATEGORY.UNPAID_FRA]),
            premiumPassTotalFee: props.premiumPassTotalFee,
            premiumPassTotalNbTransactions: props.premiumPassTotalNbTransactions,
            premiumPassTotalGrossAmount: props.premiumPassTotalGrossAmount,
            premiumPassTotalNetAmount: props.premiumPassTotalNetAmount
        };
        this.tableRowList = [];
        this.headerItemList = [];
    }

    /**
     * Quand on récupère de nouvelle props on refait l'appel WS
     * @param {*} newProps
     */
    componentWillReceiveProps(newProps) {
        this.setState({
            operationList: newProps.operationList,
            location: newProps.location,
            hasProcessingFees: this.hasCategoryInOperationList(newProps.operationList, [OPERATION_CATEGORY.PROCESSING_FEES]),
            hasRegularFra: this.hasCategoryInOperationList(newProps.operationList, [OPERATION_CATEGORY.FRA, OPERATION_CATEGORY.N43, OPERATION_CATEGORY.CODA]),
            hasUnpaidFra: this.hasCategoryInOperationList(newProps.operationList, [OPERATION_CATEGORY.UNPAID_FRA])
        });
    }

    renderCreditCard(cardType) {
        if(CardType[cardType]){
            return(
                <div>
                <img src={`${process.env.PUBLIC_URL}/${CardType[cardType].img}`} alt="credit card logo" /> {T.translate(CardType[cardType].name)}
            </div>
        );
        }
        return;
    }

    render() {
        this.createHeaderItems();
        if (this.state.operationList && this.state.operationList.length > 0) {
            this.setTableRowList();
            return(
                <Table className="tableStripped"
                       fixedHeader={true}
                       fixedFooter={true}>
                    {this.getTableHeader()}
                    <TableBody
                        displayRowCheckbox={false}
                        stripedRows={true}>
                        {this.tableRowList}
                    </TableBody>
                </Table>
            );
        } else { // Si on n'a 0 données on affiche un message
            return (
                <div>{T.translate("table.empty")}</div>
            );
        }
    }

    getStrippedStyle(index) {
        return { 'backgroundColor': index % 2 ? ColorEnum.WHITE : '#eeeeee' };
    }

    /**********************************************
     * ********* Contruction du tableau ***********
     **********************************************/

    /**
     *  Création du body du tableau
     */
    setTableRowList() {
        // ES ou BE, sans impayés
        if(this.state.location !== 'FR') {
            this.tableRowList = this.state.operationList.map((data, index) => {
                    return <TableRow key={index}>
                        <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip">
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                <div className="actionButton" onClick={() => {this.props.handleInvoiceDownload(data.idInvoice)}}>
                                    {data.contractNumber}
                                </div>
                                :
                                <div className="">{data.contractNumber}</div>
                            }
                            <span className="hooverText"> {data.contractNumber} </span>
                        </TableRowColumn>
                        <TableRowColumn className="tooltip" style={this.getStrippedStyle(index)}>
                            <div className=""> {data.nameShop} </div>
                            <span className="hooverText"> {data.nameShop} </span>
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(index)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                ''
                                :
                                data.tradeDate != null ? data.tradeDate : '-'}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {/*pas de carte même si proceesingFees pour garder une cohérence, à changer si demande client*/}
                            {this.state.location === 'BE' ? this.renderCreditCard(data.cardType) : ''}
                            {this.state.location === 'ES' && data.operationType && data.sens ? OperationTypeEnum[data.operationType.toString() + data.sens.toString()] : ''}
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip">
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                <div>
                                    <div className=""> {T.translate('table.processingFees')} </div>
                                </div>
                                :
                                data.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                            }
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                this.getAmountString(0)
                                :
                                this.getAmountString(data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {this.getAmountString(data.netAmount - data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {this.getAmountString(data.netAmount)}
                        </TableRowColumn>
                    </TableRow>
                }
            )
        } else {
            this.tableRowList = this.state.operationList.map((data, index) => {
                    return <TableRow key={index}>
                        {
                            this.renderFRContractNumberColumn(data, index)
                        }
                        <TableRowColumn className="tooltip" style={this.getStrippedStyle(index)}>
                            <div className=""> {data.nameShop} </div>
                            <span className="hooverText">{data.nameShop}</span>
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(index)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                ''
                                :
                                data.tradeDate != null ? data.tradeDate : '-'}
                        </TableRowColumn>
                        {this.props.selectedStreamType === STREAM_TYPE.PASS_CARD ?
                            null :
                            this.renderOperationActivity(data, index)
                        }
                        <TableRowColumn style={this.getStrippedStyle(index)} className="alignRight">
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES || data.nbTransactions == null ?
                                ''
                                :
                                data.nbTransactions.toString()}
                        </TableRowColumn>
                        <TableRowColumn style={this.getStrippedStyle(index)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                <div>
                                    <div className=""> {T.translate('table.processingFees')} </div>
                                </div>
                                :
                                data.sens > 0 ? T.translate('table.debit') : T.translate('table.credit')
                            }
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {data.category === OPERATION_CATEGORY.PROCESSING_FEES ?
                                this.getAmountString(0)
                                :
                                this.getAmountString(data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {this.getAmountString(data.netAmount - data.grossAmount)}
                        </TableRowColumn>
                        <TableRowColumn className="alignRight" style={this.getStrippedStyle(index)}>
                            {this.getAmountString(data.netAmount)}
                        </TableRowColumn>
                    </TableRow>
                }
            );
        }
    }

    /**
     * Retourne le header du tableau qui diffère si il y a des operations de frais de processing
     */
    getTableHeader() {

        let headerRowList = [];
        let hasAllTotalHeaderField = false;

        if (this.state.hasRegularFra && (this.state.hasProcessingFees || this.state.hasUnpaidFra)) {
            hasAllTotalHeaderField = true;
            headerRowList.push(this.getRowTotalRegularFra())
            if (this.props.location === 'FR') {
                headerRowList.push(this.getRowTotalProximity())
                headerRowList.push(this.getRowTotalEcommerce())
                headerRowList.push(this.getRowTotalPass())
            }
        }
        if (this.state.hasProcessingFees) {
            headerRowList.push(this.getRowTotalProcessingFees())
        }
        if (this.state.hasUnpaidFra) {
            hasAllTotalHeaderField = true;
            headerRowList.push(this.getRowTotalUnpaidFra())
        }
        // Le total dépend si on a des frais de processing ou pas, a changer plus tard
        if (this.state.hasProcessingFees || this.state.hasUnpaidFra) {
            headerRowList.push(this.getRowTotalNetBanking())
        } else {
            hasAllTotalHeaderField = true;
            headerRowList.push(this.getRowDebitCreditCommon(null))
            if (this.props.location === 'FR') {
                headerRowList.push(this.getRowTotalProximity())
                headerRowList.push(this.getRowTotalEcommerce())
                headerRowList.push(this.getRowTotalPass())
            } else {
                headerRowList.push(this.getRowDebitCreditCommon(false))
                headerRowList.push(this.getRowDebitCreditCommon(true))
            }
        }

        headerRowList.push(this.getTableHeaderFields());

        headerRowList.unshift(this.getTableTotalHeaderFields(hasAllTotalHeaderField));

        return (
            <TableHeader className="headerTableStripped" displaySelectAll={false} adjustForCheckbox={false}>
                {headerRowList}
            </TableHeader>
        )
    }

    getRowTotalNetBanking() {
        return (
            <TableRow key={'footer-net-banking'} className="important">
                <TableRowColumn colSpan={this.getSpanColumn() + 4}>
                    {T.translate('table.totalNetBanking')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalNetBanking())}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalProcessingFees() {
        return (
            <TableRow key={'footer-processing-fees'} className="important">
                <TableRowColumn colSpan={this.getSpanColumn() + 4}>
                    {T.translate('table.processingFeesInvoiceDeduction')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalProcessingFees())}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalRegularFra() {
        return (
            <TableRow key={'footer-regular-fra'} className="important">
                <TableRowColumn colSpan={this.getSpanColumn()}>
                    {T.translate('table.totalRevenues')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.getTotalTransactions(null) : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getSubtotalGrossAmount([OPERATION_CATEGORY.FRA, OPERATION_CATEGORY.CODA, OPERATION_CATEGORY.N43]))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getSubtotalCommissionAmount([OPERATION_CATEGORY.FRA, OPERATION_CATEGORY.CODA, OPERATION_CATEGORY.N43]))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getSubtotalNetAmount([OPERATION_CATEGORY.FRA, OPERATION_CATEGORY.CODA, OPERATION_CATEGORY.N43]))}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalUnpaidFra() {
        const filter = data => data.category === OPERATION_CATEGORY.UNPAID_FRA;
        return (
            <TableRow key={'footer-unpaid-fra'} className="important">
                <TableRowColumn colSpan={this.getSpanColumn()}>
                    {T.translate('table.unpaidTotal')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.getTotalTransactions(filter) : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getSubtotalGrossAmount([OPERATION_CATEGORY.UNPAID_FRA]))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getSubtotalCommissionAmount([OPERATION_CATEGORY.UNPAID_FRA]))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getSubtotalNetAmount([OPERATION_CATEGORY.UNPAID_FRA]))}
                </TableRowColumn>
            </TableRow>
        );
    }

    /**
     * Permet de créer une ligne de total pour les crédits ou les débit, ou la somme des 2 suivant le paramètre en entré
     * null -> Crédit + Débit
     * true -> Débit
     * false -> Crédit
     * @param negativeSens
     * @returns {JSX.Element}
     */
    getRowDebitCreditCommon(negativeSens){
        const filter = negativeSens === null ? null : data => (data.sens > 0 && negativeSens) || (data.sens <= 0 && !negativeSens)
        return (
            <TableRow key={'header-total-common'} className={negativeSens === null ? 'important' : ''}>
                <TableRowColumn colSpan={this.getSpanColumn()}>
                    {
                        negativeSens === null ? T.translate('table.total') :
                            negativeSens ? T.translate('table.debitTotal') : T.translate('table.creditTotal')
                    }
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.getTotalTransactions(filter) : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalGrossAmount(filter))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalComission(filter))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalNetAmount(filter))}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalProximity() {
        const filter = data => data.streamType === STREAM_TYPE.BANK_CARD.code &&
            !ECOMMERCE_ACTIVITIES.includes(data.activity)
        return (
            <TableRow key='header-proximity'>
                <TableRowColumn colSpan={this.getSpanColumn()}>
                    {T.translate('table.proximity')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.getTotalTransactions(filter) : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalGrossAmount(filter))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalComission(filter))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalNetAmount(filter))}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalEcommerce() {
        const filter = data => data.streamType === STREAM_TYPE.BANK_CARD.code &&
            ECOMMERCE_ACTIVITIES.includes(data.activity)
        return (
            <TableRow key='header-ecommerce'>
                <TableRowColumn colSpan={this.getSpanColumn()}>
                    {T.translate('table.eCommerce')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.getTotalTransactions(filter) + this.state.premiumPassTotalNbTransactions : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalGrossAmount(filter) + this.state.premiumPassTotalGrossAmount)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalComission(filter) + this.state.premiumPassTotalFee)}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalNetAmount(filter) + this.state.premiumPassTotalNetAmount)}
                </TableRowColumn>
            </TableRow>
        );
    }

    getRowTotalPass() {
        const filter = data => data.streamType === STREAM_TYPE.PASS_CARD.code;
        return (
            <TableRow key='header-pass'>
                <TableRowColumn colSpan={this.getSpanColumn()}>
                    {T.translate('table.pass')}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.props.location === 'FR' ? this.getTotalTransactions(filter) : null}
                </TableRowColumn>
                <TableRowColumn className="tinyColumn" />
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalGrossAmount(filter))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalComission(filter))}
                </TableRowColumn>
                <TableRowColumn className="alignRight">
                    {this.getAmountString(this.getTotalNetAmount(filter))}
                </TableRowColumn>
            </TableRow>
        );
    }

    renderOperationActivity(data, index){
        const activityData = OperationService.getDataActivity(data);
        return (
            <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip">
                <div>
                    {activityData.text}
                </div>
                <span className="hooverText"> {activityData.hover} </span>
            </TableRowColumn>
        );
    }

    renderFRContractNumberColumn(data, index) {
        if(OPERATION_CATEGORY.PROCESSING_FEES === data.category) {
            return (
                <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip">
                    <div className="actionButton" onClick={() => {this.props.handleInvoiceDownload(data.idInvoice)}}>
                        {data.contractNumber}
                    </div>
                    <span className="hooverText"> {data.contractNumber} </span>
                </TableRowColumn>
            )
        } else {
            /*Pour les flux Pass on affiche le code PASS dans le numéro de contrat */
            return(
                <TableRowColumn style={this.getStrippedStyle(index)} className="tooltip">
                    <div className="">{data.streamType === STREAM_TYPE.PASS_CARD.code ? data.shopPass : data.contractNumber}</div>
                    <span className="hooverText">{data.streamType === STREAM_TYPE.PASS_CARD.code ? data.shopPass : data.contractNumber}</span>
                </TableRowColumn>
            )
        }
    }

    /*********************************************
     * ************ Table Header *****************
     *********************************************/


    /**
     * Crée la liste des éléments qui doivent être dans le header
     */
    createHeaderItems() {
        this.headerItemList = [
            {
                type: FilterType.contractNumber,
                isNumber: true,
                text: T.translate("table.contractNumber")
            },
            {
                type: FilterType.nameShop,
                isNumber: false,
                text: T.translate("table.nameShop")
            },
            {
                type: FilterType.tradeDate,
                isNumber: true,
                showToolTip: true,
                text: T.translate("table.tradeDateShort"),
                textLong: T.translate("table.periodic.transactionDateLong"),
            },
            this.getCorrectColumn(),
            {
                type: FilterType.sens,
                isNumber: false,
                text: T.translate("table.sens")
            },
            {
                type: FilterType.grossAmount,
                isNumber: true,
                alignRight: true,
                text: T.translate("table.grossAmount") + " €"
            },
            {
                type: FilterType.COMMISSION,
                isNumber: true,
                alignRight: true,
                text: T.translate("table.commission") + " €"
            },
            {
                type: FilterType.netAmount,
                isNumber: true,
                alignRight: true,
                text: T.translate("table.netAmout") + " €"
            }
        ];

        if(this.props.location === 'FR') {
            this.headerItemList.splice(4, 0, this.getNbTransactionColumn());
        }
    }

    getSpanColumn() {
        return this.headerItemList.filter(value => !!value).length - 5;
    }

    /**
     * Récupère la bonne colonne entre le coda et le n43
     */
    getCorrectColumn() {
        if (this.props.selectedStreamType === STREAM_TYPE.PASS_CARD) {
            return null;
        }
        if(this.props.location === 'BE') {
            return {
                type: FilterType.cardType,
                isNumber: false,
                alignRight: true,
                text: T.translate("table.cardType")
            };
        } else if(this.props.location === 'FR') {
            return {
                type: FilterType.activity,
                isNumber: false,
                text: T.translate("table.activity")
            }
        }
        // cas par défaut : ES
        return {
            type: FilterType.operationType,
            isNumber: false,
            text: T.translate("table.operationType")
        };
    }

    getNbTransactionColumn() {
        return {
            type: FilterType.nbTransactions,
            isNumber: true,
            alignRight: true,
            text: T.translate("table.nbTransactionsLong"),
        };
    }

    /**
     * Retourne les éléments présent dans le header
     */
    getTableHeaderFields() {
        return (
            <TableRow key="header-fields" className="headerFieldRow">
                {this.headerItemList.map((item) => {
                    if (!!item) {
                        return (
                            <TableHeaderColumn key={item.type} className={item.class}>
                                <SortComponent isSelected={this.state.selectedFilter === item.type}
                                               alignRight={item.alignRight}
                                               showToolTip={item.showToolTip} action={(desc) => {
                                    if (item.type === FilterType.COMMISSION) {
                                        this.sortDataByCommision(desc)
                                    } else if (item.type === FilterType.tradeDate) {
                                        this.sortByDate(desc)
                                    } else if (item.isNumber) {
                                        this.sortNumber(item.type, desc)
                                    } else {
                                        this.sortString(item.type, desc)
                                    }
                                }} text={item.text} textLong={item.textLong}/>
                            </TableHeaderColumn>
                        )
                    }
                    return null;
                })
                })
            </TableRow>
        )
    }

    /**
     * Retourne les éléments présent dans le header des totaux
     */
    getTableTotalHeaderFields(displayAllField = true) {
        return (
            <TableRow key="total-header" className="headerFieldRow">
                <TableRowColumn colSpan={this.getSpanColumn()} />
                <TableHeaderColumn className="alignRight">
                    {this.props.location === 'FR' ? T.translate("table.nbTransactionsLong") : null}
                </TableHeaderColumn>
                <TableRowColumn className="tinyColumn" />
                <TableHeaderColumn className="alignRight">
                    {displayAllField ? T.translate("table.grossAmount") + ' €' : ''}
                </TableHeaderColumn>
                <TableHeaderColumn className="alignRight">
                    {displayAllField ? T.translate("table.commission") + ' €' : ''}
                </TableHeaderColumn>
                <TableHeaderColumn className="alignRight">
                    {T.translate("table.netAmout")} €
                </TableHeaderColumn>
            </TableRow>
        )
    }


    /**********************************************
     * ************ Calcul des totaux *************
     **********************************************/
    getTotalGrossAmount(filter) {
        let grossAmount = 0;
        this.state.operationList
            .filter(data => data.category !== OPERATION_CATEGORY.PROCESSING_FEES && (!filter || filter(data)))
            .forEach(data => {
                grossAmount += data.grossAmount;
            });
        return grossAmount;
    }

    getTotalTransactions(filter) {
        let nbTransactions = 0;
        this.state.operationList
            .filter(data => data.category !== OPERATION_CATEGORY.PROCESSING_FEES && (!filter || filter(data)))
            .forEach(data => {
                nbTransactions += data.nbTransactions;
            });
        return nbTransactions;
    }

    getTotalNetAmount(filter) {
        let netAmount = 0;
        this.state.operationList
            .filter(data => data.category !== OPERATION_CATEGORY.PROCESSING_FEES && (!filter || filter(data)))
            .forEach(data => {
                netAmount += data.netAmount;
            });
        return netAmount;
    }

    getAmountString(amount) {
        return (amount > 0 ? '+ ' : '') + amount.toPrice();
    }

    getTotalComission(filter) {
        const totalGrossAmount = this.getTotalGrossAmount(filter);
        const totalNetAmount = this.getTotalNetAmount(filter);
        return (totalNetAmount - totalGrossAmount);
    }

    /**
     * Calcule la somme total net en incluant les frais de processing
     * @returns {number}
     */
    getTotalNetBanking() {
        let netBanking = 0;
        this.state.operationList
            .forEach((data) => {
                netBanking += data.netAmount;
            });
        return netBanking;
    }

    /**
     * Calcule la somme des frais de processing
     * @returns {number}
     */
    getTotalProcessingFees() {
        let totalProcessingFees = 0;
        this.state.operationList
            .filter((data => data.category === OPERATION_CATEGORY.PROCESSING_FEES))
            .forEach((data) => {
                totalProcessingFees += data.netAmount;
            });
        return totalProcessingFees;
    }

    /**********************************************
     * ************ Trie du tableau ***************
     **********************************************/

    sortNumber(category, desc) {
        const sortedData = this.state.operationList.sort(function(a, b) {
            if(desc) {
                return a[category] > b[category] ? -1 : 1;
            }
            return b[category] > a[category] ? -1 : 1;
        });
        this.setState({
            selectedFilter: FilterType[category],
            operationList: sortedData
        });
    }

    sortByDate(desc) {
        const sortedData = this.state.operationList.sort(function(a, b) {
            //On met les operations de processing fees à la fin
            if (a.category === OPERATION_CATEGORY.PROCESSING_FEES) {
                return 1;
            }
            if (b.category === OPERATION_CATEGORY.PROCESSING_FEES) {
                return -1;
            }
            if (a.tradeDate && b.tradeDate) {
                let dateA = new Date().createFrenchDate(a.tradeDate)
                let dateB = new Date().createFrenchDate(b.tradeDate)
                if (desc) {
                    return dateA > dateB ? -1 : 1;
                }
                return dateB > dateA ? -1 : 1;
            }
            return 1;
        });
        this.setState({
            selectedFilter: FilterType.tradeDate,
            operationList: sortedData
        });
    }

    sortString(category, desc) {
        const sortedData = this.state.operationList.sort(function(a, b) {
            return sortAlphabetically(a[category], b[category], desc);
        });
        this.setState({
            selectedFilter: FilterType[category],
            operationList: sortedData
        });
    }

    sortDataByCommision(desc) {
        const sortedData = this.state.operationList.sort(function(a, b) {
            if( desc ) {
                return (a.grossAmount - a.netAmount) - (b.grossAmount - b.netAmount);
            }
            return (b.grossAmount - b.netAmount) - (a.grossAmount - a.netAmount);
        });
        this.setState({
            selectedFilter: FilterType.COMMISSION,
            operationList: sortedData
        });
    }

    /**
     * Méthode qui vérifie si il y a au moins une operation avec une categorie appartenant à la liste de categorie passée en param
     * @param operationList
     * @param categoryList
     * @returns {boolean}
     */
    hasCategoryInOperationList(operationList, categoryList) {
        if (operationList && operationList.length > 0) {
            return operationList.some(operation => categoryList.includes(operation.category));
        }
        return false;
    }

    getSubtotalCommissionAmount(categoryList) {
        return -(this.getSubtotalGrossAmount(categoryList) - this.getSubtotalNetAmount(categoryList));
    }

    getSubtotalGrossAmount(categoryList) {
        let totalOperation = 0;
        this.state.operationList
            .filter((data => categoryList.includes(data.category)))
            .forEach((data) => {
                totalOperation += data.grossAmount;
            });
        return totalOperation;
    }

    getSubtotalNetAmount(categoryList) {
        let totalOperation = 0;
        this.state.operationList
            .filter((data => categoryList.includes(data.category)))
            .forEach((data) => {
                totalOperation += data.netAmount;
            });
        return totalOperation;
    }
}

export default TableStripped;



// WEBPACK FOOTER //
// ./src/components/tableComponent/TableStripped.js